import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Form, Input, Typography, message } from 'antd'
import axios from 'axios'

interface OrganisationFormValues {
  orga_name: string
  product_global_name: string
}

interface SaveResponse {
  ok: boolean
  redirect?: string
  errors?: string
}

export function NewOrganisation() {
  const history = useHistory()
  const [form] = Form.useForm<OrganisationFormValues>()
  const [saving, setSaving] = useState(false)

  const onFinish = async (values: OrganisationFormValues) => {
    setSaving(true)
    try {
      const body = new URLSearchParams()
      body.set('orga_name', values.orga_name || '')
      body.set('product_global_name', values.product_global_name || '')

      const { data } = await axios.post<SaveResponse>(
        '/organisations',
        body,
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          validateStatus: status => status < 500,
        }
      )

      if (data.ok && data.redirect) {
        message.success('Organisation enregistrée')
        history.push('/organisations')
        return
      }

      if (data.errors) {
        message.error(data.errors)
      }
    } catch (error) {
      console.error(error)
      message.error("Erreur lors de l'enregistrement")
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={{ marginTop: 16, maxWidth: 520 }}>
      <Typography.Title level={4} style={{ marginBottom: 24 }}>
        Ajouter organisation
      </Typography.Title>

      <Form form={form} layout="vertical" onFinish={onFinish} requiredMark>
        <Form.Item
          label="Nom"
          name="orga_name"
          rules={[{ required: true, message: 'Nom requis' }]}
          className='no-box-shadow'
        >
          <Input autoFocus />
        </Form.Item>

        <Form.Item
          label="Nom du produit (ex. : Loom)"
          name="product_global_name"
          rules={[{ required: true, message: 'Nom du produit requis' }]}
          className='no-box-shadow'
        >
          <Input />
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
          <Button onClick={() => history.push('/organisations')}>Annuler</Button>
          <Button type="primary" htmlType="submit" loading={saving}>
            Enregistrer
          </Button>
        </div>
      </Form>
    </div>
  )
}
